import {InjectionToken} from '@angular/core';

export const CORE_CONFIG = new InjectionToken<CoreConfig>('CORE_CONFIG_PARAMS');

export class CoreConfig {
  coreApiUrl: string;
  requiredRole: string;
}
